'use client'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import useLogo from '@/hooks/useLogo'
import { useTranslation } from 'react-i18next'
import Link from '@/components/common/Link'

export default function Brand() {
  const { t } = useTranslation()
  const logoDesktop = useLogo('gearsOfWarFull')
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down('lg'))

  return (
    <Link href='https://gearsofwar.com' title={t('Gears of War Website')} sx={{ display: 'flex' }}>
      <img
        src={logoDesktop}
        width={isMobile ? 174 : 224}
        height={isMobile ? 55 : 71}
        alt={t('Gears of War Logo')}
        title={t('Gears of War Website')}
      />
    </Link>
  )
}
